import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

import {EntitySelect} from './entity-select';

type Props = {
    name: string;
    value: string;
    nullOptionText?: string;
    anyOptionText?: string;
    affirmativeOptionText?: string;
    negativeOptionText?: string;
    isNot: boolean;
    hierarchyTypeFilter: string;
    onChange: (data: string) => any;
    onFilterNegationChange: (value: string, isNot: boolean) => any;
    onClearValue: () => void;
};

export function FormAccountHierarchy(props: Props) {
    const handleSelectChange = (value?: string | null) => {
        if (value) {
            props.onChange(value);
        } else {
            props.onClearValue();
        }
    };

    const select = (
        <EntitySelect
            types={['accounts']}
            value={props.value}
            onChange={handleSelectChange}
            onClearValue={props.onClearValue}
            hierarchyTypeFilter={props.hierarchyTypeFilter}
        />
    );

    const getSelectedValue = () => {
        if (props.value === '-' && !props.isNot) {
            return 'null';
        }

        if (props.value === '-' && props.isNot) {
            return 'any';
        }

        if (props.isNot) {
            return 'negative';
        }

        return 'affirmative';
    };

    const selectedValue = getSelectedValue();

    const handleRadioButtonChange = (value: string) => {
        if (value === 'null') {
            props.onFilterNegationChange('-', true);
        } else if (value === 'any') {
            props.onFilterNegationChange('-', false);
        } else if (value === 'affirmative') {
            props.onFilterNegationChange('', true);
        } else if (value === 'negative') {
            props.onFilterNegationChange('', false);
        } else {
            props.onFilterNegationChange(value, true);
        }
    };

    return (
        <RadioGroup
            selectedValue={selectedValue}
            name={props.name}
            onChange={handleRadioButtonChange}
        >
            <Radio value='any'>{props.anyOptionText}</Radio>
            <Radio value='affirmative'>{props.affirmativeOptionText}</Radio>
            {selectedValue === 'affirmative' ? <div>{select}</div> : null}
            <Radio value='negative'>{props.negativeOptionText}</Radio>
            {selectedValue === 'negative' ? <div>{select}</div> : null}
            <Radio value='null'>{props.nullOptionText}</Radio>
        </RadioGroup>
    );
}
